import DashStore from "./v2/Store";
import DashEvent from "./v2/Event";
import { dispatchEvent } from './v2/index';
export default {
  DashStore: DashStore,
  DashEvent: DashEvent,
  dispatchEvent: dispatchEvent
};